import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useExamScoreStyle from "./styles";
import SidePannel from "./SidePannel";
import sidePannelData from "./sidePannelData";
import MyExam from "./ViewExam/Exam";
import Header from "./header";
import { useProfile } from "../../context/ProfileContext";
import { Typography, Box } from "@mui/material";
import JeeRegistrationPopup from "./JeeRegistrationPopup";

function DashboardMain() {
  const classes = useExamScoreStyle();
  const location = useLocation();
  const currentRoute = location.pathname;

  const [header, setHeader] = useState(sidePannelData);
  const [menuCollapse, setMenuCollapse] = useState(false);
  const { profile, fetchProfileData } = useProfile();
  const [open, setOpen] = useState(true);

  const user = {
    image: profile?.image_url || "N/A",
    rollNumber: profile?.learner_information?.roll_number || null,
    full_name: profile?.full_name || null,
  };

  const handleMenuCollapse = () => {
    setMenuCollapse(!menuCollapse);
  };

  useEffect(() => {
    fetchProfileData();
    if (sessionStorage.getItem("jeeDetails") !== "no") {
      setOpen(false);
    }
  }, []);

  // Function to render content based on current route
  const renderContent = () => {
    switch (currentRoute) {
      case "/myexam":
        return <MyExam />;
      default:
        return <div>404 - Page Not Found</div>; // optional fallback
    }
  };

  return (
    <div className={`${classes.dflex} ${classes.w100}`}>
      {/* <div
        className={`${menuCollapse ? classes.w5 : classes.w20} ${classes.shadowright}`}
      >
        <SidePannel
          menuCollapse={menuCollapse}
          header={header}
        />
      </div> */}

      <div
        className={`${menuCollapse ? classes.w100 : classes.w100} ${classes.h100vh
          }`}
      >
        <div className={classes.header}>
          <Header
            handleMenuCollapse={handleMenuCollapse}
            menuCollapse={menuCollapse}
          />
          {/* w75 on desktop → 100% on mobile */}
          <Box
            // className={classes.h50}
            sx={{
              width: { xs: "90%", md: "75%" },
              margin: "auto",
              paddingTop: "20px",
              boxSizing: "border-box",
              px: { xs: 0, md: 0 },
            }}
          >
            {/* w85 on desktop → 100% on mobile */}
            <Box
              className={`${classes.dflex} ${classes.justifyspacebetween}`}
              sx={{
                width: { xs: "100%", md: "85%" },
                margin: "auto",
              }}
            >
              {/* 50% on desktop → 100% on mobile */}
              <Box sx={{ width: { xs: "55%", sm: "50%" } }}>
                <div>
                  <Typography sx={{ fontSize: { xs: "0.8rem", sm: "1rem", md: "1.25rem" } }}>Welcome</Typography>
                  <Typography sx={{ fontSize: { xs: "1rem", sm: "1.2rem", md: "1.3rem", lg: "1.4rem" }, fontWeight: "bold" }}>
                    {user.full_name}
                  </Typography>
                </div>
                <div style={{ marginTop: "10px" }}>
                  <Typography sx={{ fontSize: { xs: "0.8rem", sm: "1rem", md: "1.25rem" } }}>IBT ID</Typography>
                  <Typography sx={{ fontSize: { xs: "1rem", sm: "1.2rem", md: "1.3rem", lg: "1.4rem" }, fontWeight: "bold" }}>
                    {user.rollNumber}
                  </Typography>
                </div>
              </Box>
              <div style={{ backgroundColor: "#E0E0E2", borderRadius: "10px" }}>
                <img
                  src={user.image}
                  alt="Profile IMG"
                  // className={classes.profileImage}
                  style={{ width: "150px", maxWidth: "100%" }}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = "userAvatar.png";
                  }}
                />
              </div>
            </Box>
            {renderContent()}
          </Box>
        </div>
      </div>

      {/* <JeeRegistrationPopup open={open} handleClose={() => setOpen(false)} /> */}
    </div>
  );
}

export default DashboardMain;
